<template>
  <div class="refund-analysis-wrapper">
    <!-- 版本切换器 -->
    <!-- <div class="version-switcher">
      <div class="switcher-container">
        <div class="switcher-labels">
          <span
            class="label"
            :class="{ active: !isNewVersion }"
            @click="!isNewVersion || toggleVersion()"
          >经典版</span>
          <span
            class="label"
            :class="{ active: isNewVersion }"
            @click="isNewVersion || toggleVersion()"
          >赛博版</span>
        </div>
      </div>
    </div> -->

    <!-- 组件容器 -->
    <div class="component-container" :class="{ 'transitioning': isTransitioning }">
      <!-- 经典版 -->
      <transition name="slide-fade" mode="out-in">
        <RefundAnalysisOld 
          v-if="!isNewVersion" 
          :allStore="allStore" 
          :key="'old'"
          class="analysis-component"
          ref="refundAnalysisWrapper"
        />
      </transition>

      <!-- 赛博版 -->
      <transition name="slide-fade" mode="out-in">
        <RefundAnalysis 
          v-if="isNewVersion" 
          :allStore="allStore" 
          :key="'new'"
          class="analysis-component"
          ref="refundAnalysisWrapper"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import RefundAnalysis from './RefundAnalysis.vue'
import RefundAnalysisOld from './RefundAnalysisOld.vue'

export default {
  name: 'RefundAnalysisWrapper',
  components: {
    RefundAnalysis,
    RefundAnalysisOld
  },
  props: {
    allStore: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isNewVersion: true,
      isTransitioning: false
    }
  },
  methods: {
    toggleVersion() {
      if (this.isTransitioning) return
      
      this.isTransitioning = true
      
      // 延迟切换，让动画有时间执行
      setTimeout(() => {
        this.isNewVersion = !this.isNewVersion
        this.isTransitioning = false
      }, 300)
    },
    handleQuery() {
      this.$refs.refundAnalysisWrapper && this.$refs.refundAnalysisWrapper.handleQuery();
    }
  }
}
</script>

<style lang="scss" scoped>
.refund-analysis-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 版本切换器 */
.version-switcher {
  position: fixed;
  top: 70px;
  right: 40px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 15px;
}

.switcher-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.switcher-labels {
  display: flex;
  gap: 15px;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.label {
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;

  &:hover {
    color: rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.1);
  }

  &.active {
    color: #00f2ff;
    background: rgba(0, 242, 255, 0.1);
    border-color: rgba(0, 242, 255, 0.3);
    text-shadow: 0 0 10px rgba(0, 242, 255, 0.5);
  }
}

/* 组件容器 */
.component-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &.transitioning {
    pointer-events: none;
  }
}

.analysis-component {
  width: 100%;
  height: 100%;
}

/* 过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave {
  transform: translateX(0);
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .version-switcher {
    top: 120px;
    right: 10px;
  }

  .switcher-labels {
    font-size: 10px;
    gap: 10px;
  }
}
</style>
